/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_filter_query: 'leaseManagement/set_filter_query',
    set_filter_word: 'leaseManagement/set_filter_word',
    set_filter_result_total: 'leaseManagement/set_filter_result_total',
    set_filter_default: 'leaseManagement/set_filter_default',
}

// count state 必須是 Object
const state = {
    filterQuery: {
        county: '',
        countyId: '',
        district: '',
        desposit: [0, 100000],
        rent: [0, 100000],
        rentDate: '',
        arrears: '',
        contractDate: [null, null],
    },
    filterWord: '',
    filterResultTotal: '',
    isDefault: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_LEASE_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    // FILTER_RESULT: (state) => {
    //     return state.filterResult
    // },
    // HOUSE_RESULT: (state) => {
    //     return state.houseResult
    // },
    GET_LEASE_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_LEASE_MGT_FILTER_RESULT_TOTAL: (state) => {
        return state.filterResultTotal
    },
    GET_LEASE_MGT_FILTER_COUNTY_IS_EMPTY: (state) => {
        if( state.filterQuery.county == '' ){
            return true
        }else{
            return false
        }
    },
    GET_LEASE_MGT_FILTER_DISTRICT_IS_EMPTY: (state) => {
        if( state.filterQuery.district == '' ){
            return true
        }else{
            return false
        }
    },
    GET_LEASE_MGT_FILTER_ARREARS_IS_EMPTY: (state) => {
        if( state.filterQuery.arrears == '' ){
            return true
        }else{
            return false
        }
    },
    GET_LEASE_MGT_FILTER_WORD_IS_EMPTY: (state) => {
        if( state.filterWord == '' ){
            return true
        }else{
            return false
        }
    }
}

// actions 也是以 Object 形式建構。
const actions = {
    // getHouse ( {commit} , value ) {
    //     return new Promise((resolve, reject) => {
    //         apiGetHouseStatus()
    //         .then(res => {
    //             console.log(res)
    //             if( res.data.status == "SUCCESS" ){
    //                 let value = res.data.result.location
    //                 commit(types.get_house, value);
    //                 resolve()
    //             }
    //         })
    //         .catch(err => {
    //             reject(err)
    //         })
    //         resolve()
    //     })
    // }
    setFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setFilterResultTotal ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result_total, value);
            resolve()
        })
    },
    setFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    }
}

// mutations
const mutations = {
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result_total](state, data){
        state.filterResultTotal = data
    },
    [types.set_filter_default](state){
        state.filterQuery.county = ''
        state.filterQuery.countyId = ''
        state.filterQuery.district = ''
        state.filterQuery.desposit = [0, 100000]
        state.filterQuery.rent = [0, 100000]
        state.filterQuery.rentDate = ''
        state.filterQuery.arrears= ''
        state.filterQuery.contractDate = [null, null]
        state.filterWord = ''
        state.isDefault = true
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/leaseManagement.js